import { useState, useCallback } from 'react';

interface UseSendRecordResult {
  sendRecord: (email: string, frontEndAppKey: string, sessionId: string) => Promise<void>;
  error: string | null;
  isSuccess: boolean;
}

export const useSendRecord = (): UseSendRecordResult => {
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const sendRecord = useCallback(async (email: string, frontEndAppKey: string, sessionId: string) => {
    setError(null);
    setIsSuccess(false); // Reset success flag before the request
    try {
      // Sending the record
      await window.tf.sendRecord(sessionId, email, frontEndAppKey);

      // after a successfull sendRecord we want to reset the typing history
      window.tf.reset();
      setIsSuccess(true); // Set success flag if record is sent correctly
    } catch (e: any) {
      setError('Failed to send the record');
      setIsSuccess(false); // Set success to false in case of error
    }
  }, []);

  return {
    sendRecord,
    error,
    isSuccess,
  };
};
